export default "__VITE_ASSET__CMq57wey__"